import useAuthStore from "../../stores/useAuthStore";

const PrintHeader = () => {
  const { settings } = useAuthStore();

  return (
    <div className="printHeaderContainer">
      <div className="brand-logo text-center">
        <img src="/images/institution-branding.png" style={{ maxWidth: 90, paddingRight: 10 }} alt="ATBCOE Kangere" />
      </div>
      <div style={{ width: 100 }}></div> {/* Left side spacer or logo */}
      <div style={{ flexGrow: 1, textAlign: "center", textTransform: "uppercase" }}>
        <h1 style={{ fontSize: 18, fontWeight: "bold" }}>{settings?.institutionName || "ADAMU TAFAWA BALEWA COLLEGE OF EDUCATION, KANGERE"}</h1>
        <h1 style={{ fontSize: 14, fontWeight: "bold" }}>DIRECTORATE OF STUDIES</h1>
        {settings?.affiliate && (
          <>
            <h1 style={{ fontSize: 12 }}>IN AFFILIATION TO </h1>
            <h1 style={{ fontSize: 13, fontWeight: "bold" }}>{settings.affiliate}</h1>
          </>
        )}
        <h4 style={{ fontSize: 11, marginTop: 5 }}>{settings?.address || "Main Campus, Along Bauchi-Gombe Road, Kangere, Bauchi State"}</h4>
      </div>
      <div style={{ width: 100 }}></div> {/* Right side spacer instead of BUK logo */}
    </div>
  );
};

export default PrintHeader;
